import { useEffect } from 'react';
import { useForceUpdate } from '@hooks/useForceUpdate';
import moment from 'moment';

export const useForceUpdateEverySecond = () => {
  const forceUpdate = useForceUpdate();
  useEffect(() => {
    let SS = moment().format('ss');
    let interval = setInterval(() => {
      if (SS !== moment().format('ss')) {
        SS = moment().format('ss');
        forceUpdate();
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
};
